import React from 'react'
import { IconProps } from './icons.models'

export const ClockIcon: React.FC<IconProps> = ({
    width = 12,
    height = 12,
    fillColor = '#99A1AF',
}) => {
    return (
        <svg width={width} height={height} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_611_1762)">
                <path d="M6 11C8.76142 11 11 8.76142 11 6C11 3.23858 8.76142 1 6 1C3.23858 1 1 3.23858 1 6C1 8.76142 3.23858 11 6 11Z" stroke={fillColor} strokeLinecap="round" strokeLinejoin="round" />
                <path d="M6 3V6L8 7" stroke={fillColor} strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_611_1762">
                    <rect width={width} height={height} fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}
